import { Component, OnInit } from '@angular/core';
import { MainService } from 'src/app/services/main.service';
import { io } from 'socket.io-client';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environments';

@Component({
  selector: 'app-live-gate-type',
  templateUrl: './live-gate-type.component.html',
  styleUrls: ['./live-gate-type.component.css']
})
export class LiveGateTypeComponent implements OnInit {
  socketInit: any;
  selectedGate: any = [];
  gats_arr: any;
  view: any = [1000, 200];
  viewtow: any = [1000, 300];
  stasticsLiveGates: any = [
    {
      name: 'Owners',
      value: 0
    },
    {
      name: 'Guest',
      value: 0
    },
    {
      name: 'Tenant',
      value: 0
    },
    {
      name: 'Household',
      value: 0
    },
    {
      name: 'Staff',
      value: 0
    },
    {
      name: 'VIP',
      value: 0
    }
  ];
  colorScheme: any = {
    domain: ['#3734E5', '#82BD69', '#a11726', '#17a19f', '#F9BD3B', '#c70c6f']
  };
  isDoughnut = true;
  constructor(private rest: MainService, private route: Router) {}
  socketConfig: any;
  ngOnInit() {
    this.socketConfig = io(`${environment.baseSocit}`);
    this.socketConfig.on('gate_type_access', (data: any) => {
      console.log('gate type: ');
      console.log(data);
      this.selectedGate.forEach((element: any) => {
        if (element.id == data.gate_id) {
          this.liveData(data, element);
          localStorage.setItem(
            'DataOfGateType',
            JSON.stringify(this.selectedGate)
          );
        }
      });
    });
    this.allGats();
  }

  onActivate(event: any, item: any): void {
    console.log(item);
    console.log(event);
    item.forEach((element: any) => {
      if (element.name == event.value.name) {
        element.status = !element.status;
        console.log('done');
      } else {
        element.status = false;
      }
    });
  }
  onDeactivate(event: any, item: any): void {
    console.log(item);
    console.log(event);
    item.forEach((element: any) => {
      if (element.name == event.value.name) {
        element.status = !element.status;
        console.log('done');
      } else {
        element.status = false;
      }
    });
  }

  allGats() {
    if (localStorage.getItem('DataOfGateType')) {
      this.selectedGate = [];
      this.selectedGate = localStorage.getItem('DataOfGateType');
      this.selectedGate = JSON.parse(this.selectedGate);
      this.selectedGate.forEach((element: any) => {
        this.connectwithSocket(element);
      });
      console.log(this.selectedGate);
    } else {
      this.rest.gateByType().subscribe((res: any) => {
        console.log(res);
        res.children.forEach((element: any) => {
          element.stasticsLiveGates = this.stasticsLiveGates;
          element.show = 1;
          this.selectedGate.push(element);
          this.connectwithSocket(element);
        });
        console.log(this.selectedGate);
      });
    }
  }

  gateChange(event: any) {
    if (event.isUserInput) {
      if (event.source.selected == true) {
        this.connectwithSocket(event.source.value);
      }
      console.log(event.source.value, event.source.selected);
    }
  }

  arr_of_choisess: any = [];
  elmentStatus = false;
  getChart(event: any, item: any) {
    console.log(item);
    console.log(event);
    item.forEach((element: any) => {
      if (element.name == event.name) {
        element.status = !element.status;
        console.log('done');
      } else {
        element.status = false;
      }
    });
  }

  connectwithSocket(Elemnt?: any) {
    this.socketConfig.emit('type_state', Elemnt.id);
  }

  liveData(data: any, element: any) {
    element.stasticsLiveGates = [];
    element.show = 0;
    let unitRealtion = data['Unit Relations'];
    let staffRealtion = data.Staff;
    unitRealtion.forEach((el: any) => {
      if (el.Guest) {
        this.guestCalc(el.Guest, element);
      } else if (el.Owner) {
        this.ownersCalc(el.Owner, element);
      } else if (el.Tenant) {
        this.tenantCalc(el.Tenant, element);
      } else if (el['Main Owner']) {
        this.MainOwnerCalc(el['Main Owner'], element);
      } else {
        this.houseHoldCalc(el.Household, element);
      }
    });
    this.vipCalc(data.VIP, element);
    this.staffCalc(staffRealtion, element);
  }

  // main owners statstics
  total_main_owner = 0
  MainOwnerCalc(data: any, element: any) {
    console.log('owner', data);
    let result: any = [];
    let totalOwners: any = 0;
    data.map((el: any) => {
      let elment;
      elment = { name: Object.keys(el)[0], value: Object.values(el)[0] };
      totalOwners = totalOwners + Object.values(el)[0];
      result.push(elment);
    });
    this.total_main_owner = totalOwners
    // element.stasticsLiveGates.unshift({
    //   name: 'Main Owner',
    //   value: totalOwners,
    //   option: result,
    //   status: false
    // });

    console.log(element);
  }

  // owners statstics
  ownersCalc(data: any, element: any) {
    console.log('owner', data);
    let result: any = [];
    let totalOwners: any = 0;
    data.map((el: any) => {
      let elment;
      elment = { name: Object.keys(el)[0], value: Object.values(el)[0] };
      totalOwners = totalOwners + Object.values(el)[0];
      result.push(elment);
    });
    element.stasticsLiveGates.unshift({
      name: 'Owner',
      value: totalOwners + this.total_main_owner,
      option: result,
      status: false
    });

    console.log(element);
  }

  // guest statsitcs

  guestCalc(data: any, elemnt: any) {
    let result: any = [];
    let totalGuest: any = 0;
    data.map((el: any) => {
      let elment;
      elment = { name: Object.keys(el)[0], value: Object.values(el)[0] };
      totalGuest = totalGuest + Object.values(el)[0];
      result.push(elment);
    });

    elemnt.stasticsLiveGates.push({
      name: 'Guest',
      value: totalGuest,
      option: result,
      status: false
    });
    // elemnt.stasticsLiveGates.push(

    // )
  }

  // tenatn statsitcs
  tenantCalc(data: any, elemnt: any) {
    let result: any = [];
    let totalTentat: any = 0;
    data.map((el: any) => {
      let elment;
      elment = { name: Object.keys(el)[0], value: Object.values(el)[0] };
      totalTentat = totalTentat + Object.values(el)[0];
      result.push(elment);
    });

    elemnt.stasticsLiveGates.push({
      name: 'Tenant',
      value: totalTentat,
      option: result,
      status: false
    });
  }

  //house statsitcs
  houseHoldCalc(data: any, elemnt: any) {
    let result: any = [];
    let totalHousehold: any = 0;
    console.log('houseHoldCalc', data);
    data.map((el: any) => {
      let elment;
      elment = { name: Object.keys(el)[0], value: Object.values(el)[0] };
      totalHousehold = totalHousehold + Object.values(el)[0];
      result.push(elment);
    });

    elemnt.stasticsLiveGates.push({
      name: 'Household',
      value: totalHousehold,
      option: result,
      status: false
    });
  }

  // staff statsitcs
  staffCalc(data: any, element: any) {
    let result: any = [];
    let totalstaff: any = 0;

    data.forEach((element: any) => {
      // let elment
      element[Object.keys(element)[0]].map((el: any) => {
        // elment = { "key": Object.keys(el)[0], "value": Object.values(el)[0] }
        totalstaff = totalstaff + Object.values(el)[0];
      });
      // result.push(elment)
    });

    let keyName = Object.keys(data[0])[0];
    data[0][keyName].map((el: any) => {
      let elment;
      elment = { name: Object.keys(el)[0], value: Object.values(el)[0] };
      result.push(elment);
    });

    element.stasticsLiveGates.push({
      name: 'staff',
      value: totalstaff,
      option: result,
      status: false
    });
  }

  vipCalc(data: any, element: any) {
    let result: any = [];
    let totalVip: any = 0;

    data.forEach((element: any) => {
      element[Object.keys(element)[0]].map((el: any) => {
        let elment;
        // elment = { "key": Object.keys(el)[0], "value": Object.values(el)[0] }
        totalVip = totalVip + Object.values(el)[0];
        // result.push(elment)
      });
    });
    let keyName = Object.keys(data[0])[0];
    data[0][keyName].map((el: any) => {
      let elment;
      elment = { name: Object.keys(el)[0], value: Object.values(el)[0] };
      result.push(elment);
    });

    element.stasticsLiveGates.push({
      name: 'VIP',
      value: totalVip,
      option: result,
      status: false
    });
  }

  moreGate(id: any) {
    this.route.navigate(['pages/gate_types', id]);
  }
}
